import type {
  EquityDataRequestForAPIClient,
  EquityDataRequestForAPI,
} from "@/interfaces/dataRequest/equity";

export function getRequestObjectForAPI(
  payload: EquityDataRequestForAPIClient
): EquityDataRequestForAPI {
  const requestPayload: EquityDataRequestForAPI = {
    geoIds: payload.markets,
    audienceType: payload.base,
    filters: payload.filters,
    segments: payload.segments,
    statTesting: payload.statTest,
    fromDate: payload.startDate,
    toDate: payload.endDate,
  };

  if (payload.module) {
    requestPayload["module"] = payload.module;
  }

  if (payload?.secondaryBrands && payload?.secondaryBrands?.length > 0) {
    requestPayload["competitors"] = payload.secondaryBrands;
  }

  if (payload.brands) {
    requestPayload["brandIds"] = payload.brands;
  }

  if (payload.brand) {
    requestPayload["brandIds"] = [payload.brand];
  }

  if (payload.markets) {
    requestPayload["geoIds"] = payload.markets;
  }

  if (payload.market) {
    requestPayload["marketId"] = payload.market;
  }

  if (payload.intervalType) {
    requestPayload["trend"] = {
      intervalUnit: payload.intervalType,
    };
    // send stat testing as NONE for moving average period
    if (
      ["MV_1", "MV_2", "MV_4", "MV_8", "MV_12"].includes(payload.intervalType)
    ) {
      requestPayload["statTesting"] = "NONE";
    }
  }

  return requestPayload;
}

export function getRequestObjectForAPIForPrePost(
  payload: EquityDataRequestForAPIClient
): EquityDataRequestForAPI {
  const requestPayload: EquityDataRequestForAPI = {
    geoIds: payload.markets,
    audienceType: payload.base,
    filters: payload.filters,
    module: payload.module,
    segments: payload.segments,
    statTesting: payload.statTest,
    prepost: {
      group: payload.group || "",
      preFromDate: payload.prePeriodStartDate || "",
      preToDate: payload.prePeriodEndDate || "",
      postFromDate: payload.periodStartDate || "",
      postToDate: payload.periodEndDate || "",
    },
    viewMode: payload.viewMode ?? null,
    scoreType: payload?.scoreType ?? null,
  };

  if (payload.brands) {
    requestPayload["brandIds"] = payload.brands;
  }

  if (payload.brand) {
    requestPayload["brandIds"] = [payload.brand];
  }

  if (payload.markets) {
    requestPayload["geoIds"] = payload.markets;
  }

  if (payload.market) {
    requestPayload["marketId"] = payload.market;
  }

  if (payload.intervalType) {
    requestPayload["trend"] = {
      intervalUnit: payload.intervalType,
    };
  }

  return requestPayload;
}
